import React from 'react';
const SNAKKER_LOGO = 'https://cdn.magicpatterns.com/uploads/98Gnmk6tUobFbbxiaTEqD8/image.png';
export function PresentationLogo() {
  return <img src={SNAKKER_LOGO} alt="Snakker" className="h-6 w-auto object-contain" data-id="element-741" data-mp="3v54u2dh2igds" />;
}